export const API_BASE_URL = '/_api/frontend-module'
export const BOOKINGS_APP_DEF_ID = '13d21c63-b5ec-5912-8397-c3a5ddb27a97'
